import { CommonModule } from '@angular/common';
import {
  Component,
  OnDestroy,
  OnInit,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DxDataGridModule } from 'devextreme-angular';
import { ActivatedRoute, Router } from '@angular/router';
import { map, Subject, takeUntil } from 'rxjs';
import {
  InventoryItem,
  InventoryItemWithoutThirdpartyRights,
  InventoryService,
  ProjectService,
} from '@shared/models';
import {
  RowRemovingEvent,
  SelectionChangedEvent,
} from 'devextreme/ui/data_grid';

@Component({
  selector: 'app-inventory-list-view',
  imports: [CommonModule, TranslateModule, DxDataGridModule],
  templateUrl: './inventory-list-view.component.html',
  styleUrl: './inventory-list-view.component.scss',
})
export class InventoryListViewComponent implements OnInit, OnDestroy {
  @Input() context: {
    selection: boolean;
    removing: boolean;
    inventory_items: InventoryItemWithoutThirdpartyRights[];
  } = {
    selection: false,
    removing: false,
    inventory_items: [],
  };
  @Output() selected_items = new EventEmitter<number[]>();
  @Output() ItemRemoved = new EventEmitter<InventoryItem>();
  private onDestroy = new Subject<void>();
  private projectId: number | null;

  public selectionMode = 'none';
  public removingActivated = false;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public readonly inventoryService: InventoryService,
    public readonly projectService: ProjectService
  ) {
    this.projectId = null;
  }

  ngOnInit(): void {
    if (this.context.selection) {
      this.selectionMode = 'multiple';
    }
    this.removingActivated = this.context.removing;
  }

  ngOnDestroy(): void {
    this.onDestroy.next();
    this.onDestroy.complete();
  }

  public edit = ({ row }: { row: { data: InventoryItem } }) =>
    this.router.navigate([
      '/project',
      this.projectId,
      'inventory',
      row.data.id,
      'view',
    ]);

  removeInventory(e: RowRemovingEvent) {
    this.ItemRemoved.emit(e.data);
  }

  onselect(e: SelectionChangedEvent) {
    const selected_ids = e.selectedRowsData.map((x) => x.id);
    this.selected_items.emit(selected_ids);
  }
}
